import {
  EPOST_FORM_FIELDS_NAME_C4_ENVELOPE,
  EPOST_FORM_FIELDS_NAME_COLOR,
  EPOST_FORM_FIELDS_NAME_LETTERS,
  EPOST_FORM_FIELDS_NAME_PAGES_COUNT,
  EPOST_FORM_FIELDS_NAME_PRINT_SIDE,
  EPOST_FORM_FIELDS_NAME_PROVIDER,
  EPOST_FORM_FIELDS_NAME_REGISTERED_LETTER,
  EpostCell,
  getEpostFormFieldsC4EnvelopeOptions,
  getEpostFormFieldsRegisteredLetterOptions,
  trasformEpostFormFieldsApiColorSchemeToOptionValue,
  trasformEpostFormFieldsApiPrinterSideToOptionValue,
} from '../../../Epost'
import { toUserMultiValue } from '../../../User'

export function toPreparedUserValue(value, itemsLength) {
  return [toUserMultiValue(value), ...Array.from({ length: itemsLength - 1 })]
}

export function getDocFlowSendingEpostContentInitialValues(epostSettings, t) {
  const registeredLetterOptions = getEpostFormFieldsRegisteredLetterOptions(t)

  return {
    [EPOST_FORM_FIELDS_NAME_C4_ENVELOPE]: getEpostFormFieldsC4EnvelopeOptions(
      t
    ).find(item => item.value === epostSettings[EpostCell.C4Envelope]),
    [EPOST_FORM_FIELDS_NAME_COLOR]:
      trasformEpostFormFieldsApiColorSchemeToOptionValue(
        epostSettings[EpostCell.Color]
      ),
    [EPOST_FORM_FIELDS_NAME_LETTERS]: epostSettings[EpostCell.Letters],
    [EPOST_FORM_FIELDS_NAME_PAGES_COUNT]: epostSettings[EpostCell.PagesCount],
    [EPOST_FORM_FIELDS_NAME_PRINT_SIDE]:
      trasformEpostFormFieldsApiPrinterSideToOptionValue(
        epostSettings[EpostCell.Duplex]
      ),
    [EPOST_FORM_FIELDS_NAME_PROVIDER]: t(
      epostSettings[EpostCell.VendorTranslationKey]
    ),
    [EPOST_FORM_FIELDS_NAME_REGISTERED_LETTER]:
      registeredLetterOptions.find(
        item => item.value === epostSettings[EpostCell.RegisteredLetter]
      ) || registeredLetterOptions[0],
  }
}
